import { render, staticRenderFns } from "./LeccionD2.vue?vue&type=template&id=fd624286&"
import script from "./LeccionD2.vue?vue&type=script&lang=js&"
export * from "./LeccionD2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports